// extracted by mini-css-extract-plugin
module.exports = {"bubble":"au8_au9","bubbleContainer":"au8_ava","icon":"au8_b8"};